import styled from "styled-components";
import { SanitisedHtmlContentStyles } from "../../types/styles";
import { sanitize } from "isomorphic-dompurify";

const StyledSanitisedHtmlContent = styled.div<{
  styles: SanitisedHtmlContentStyles;
}>`
  color: ${({ styles }) => styles.OverallGeneralTextColour};
`;

export type SanitisedHtmlContentProps = {
  content: string;
  styles: SanitisedHtmlContentStyles;
};

export const SanitisedHtmlContent: React.FC<SanitisedHtmlContentProps> = ({
  content,
  styles,
}) => {
  return (
    <StyledSanitisedHtmlContent
      styles={styles}
      dangerouslySetInnerHTML={{ __html: sanitize(content) }}
    />
  );
};
